import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from "../components/PopUP";
import api from "../Api";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {IMAGE_URL} from "../utils/constants";

const BlackBoxList = () => {
  const [popupMessage, setPopupMessage] = useState("Loading page content...");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  const [sets, setSets] = useState([])
  const pathParts = pathname.split("/").filter(Boolean);

  const level = decodeURIComponent(pathParts[2]).toLowerCase();

  useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await api.get(`blackbox/admin/sets?level=${level}`);
        setSets(response.data.data);
      } catch (error) {
        console.error("API Error:", error.message);
      }

      setLoading(false);
    };

    fetchData();
  }, [pathname]);


  const goToQuestions = (id) => {
    navigate(`${id}`);
  };

  const approveQuestionSet = async (id) => {
    try {
      const payload = {
        set_id: id,
        action: 'approve',
      };

      await api.patch('blackbox/admin/question-action', payload);
      setPopupMessage("Question approved successfully");
      
      // Update the sets list
      const updatedSets = sets.map(set => 
        set.id === id ? { ...set, is_approve: true } : set
      );
      setSets(updatedSets);
    } catch (err) {
      console.error(err);
      setPopupMessage("Failed to approved set questions");
    }
  };

  const rejectQuestionSet = async (id) => {
    try {
      const payload = {
        set_id: id,
        action: 'reject',
      };

      await api.patch('blackbox/admin/question-action', payload);
      setPopupMessage("Question rejected successfully");
      
      // Update the sets list
      const updatedSets = sets.map(set => 
        set.id === id ? { ...set, is_approve: false } : set
      );
      setSets(updatedSets);
    } catch (err) {
      console.error(err);
      setPopupMessage("Failed to reject set questions");
    }
  };

  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <h1 className="mb-2 mt-3">
                          Available Sets for Boxes: {level.replace("_", " ").replace(/^./, c => c.toUpperCase())}
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div className="common-table-wrapper mt-4">
                    <div className="common-table-filter-wrapper">
                      <div className="common-left-blk">
                        <div className="common_sub_heading_wrapper mb-0">
                          <h2>Sets listing</h2>
                        </div>
                      </div>
                    </div>

                    <div className="table-blk table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Set ID</th>
                            {/* <th>Title</th> */}
                            <th>Date Created</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sets.map((set) => (
                            <tr>
                              <td>{set.question_id.replace("_", "-").replace(/^./, c => c.toUpperCase())}</td>
                              <td>{set.created_at}</td>
                              <td>
                                <span
                                  className={`td-status ${set.is_approve === true
                                    ? "st-active"
                                    : "st-inactive"
                                    } fw-semibold`}
                                >
                                  {set.is_approve === true
                                    ? "Published"
                                    : "Not Published"}
                                </span>
                              </td>
                              <td>
                                <span className="td-action">
                                  <button
                                    className="border-0 bg-white"
                                    onClick={() => {
                                      goToQuestions(set.id);
                                    }}
                                  >
                                    <img
                                      src={IMAGE_URL+"eye-tbl-icon.svg"}
                                      alt="View"
                                    />
                                  </button>

                                  <button
                                    type="button"
                                    className="border-0 bg-white"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Publish"
                                    onClick={() => { approveQuestionSet(set.id) }}
                                    disabled={set.is_approve}
                                  >
                                    <i className="fa-solid fa-upload"></i>
                                  </button>

                                  <button
                                    type="button"
                                    className="border-0 bg-white"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Reject"
                                    onClick={() => { rejectQuestionSet(set.id) }}
                                    disabled={!set.is_approve}
                                  >
                                    <i className="fa-solid fa-ban"></i>
                                  </button>
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* footer
                          <TableFooter
                            pagination={pagination}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        /> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default BlackBoxList;
